function queryShadow(host, selector) {
  return host.shadowRoot?.querySelector(selector) ?? null;
}
function queryShadowAll(host, selector) {
  if (!host.shadowRoot) return [];
  return Array.from(host.shadowRoot.querySelectorAll(selector));
}
function getShadowStyles(host) {
  if (!host.shadowRoot) return null;
  const style = host.shadowRoot.querySelector("style");
  return style?.textContent ?? null;
}
function getShadowHTML(host) {
  if (!host.shadowRoot) return null;
  const temp = document.createElement("div");
  temp.innerHTML = host.shadowRoot.innerHTML;
  temp.querySelectorAll("style").forEach((el) => el.remove());
  const result = temp.innerHTML.trim();
  return result || null;
}
export {
  getShadowHTML,
  getShadowStyles,
  queryShadow,
  queryShadowAll
};
//# sourceMappingURL=shadow.js.map
